module.exports = new __parcel__URL__("reflect.c0b511a0.png").toString();